export default __webpack_public_path__ + "static/media/test1.0a53f751.png";